<template>
    <div v-if="$store.state.debug">
        <b class="xs-font" @click="show = !show"><i class="fa fa-bug"></i> {{show ? name : ''}}</b>
        <code v-if="show">{{entry || $store.state}}</code>
    </div>
</template>

<script>
    export default {
        props: ['entry', 'name'],
        data() {
            return {
                show: false
            }
        },
    }
</script>